import React from "react";
import { useTranslation } from "react-i18next";
import ModalBase from "../ModalBase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { ModalInfoList, ModalInfoRow } from "./ModalInfoList";

const EXTRA_INFO_KEYS = {
    Site: "entity.site",
    Charger: "entity.charger",
    Connector: "entity.connector",
};

const ConfirmModal = ({
	isOpen,
	onClose,
	onConfirm,
	title,
	message,
	icon = faTriangleExclamation,
	extraInfo = {},
	confirmLabel,
}) => {
	const { t } = useTranslation();

	return (
		<ModalBase isOpen={isOpen} onClose={onClose}>
			<div className="flex items-center justify-between mb-4">
				<h2 className="text-lg font-bold text-sky-600 flex items-center gap-2">
					<FontAwesomeIcon icon={icon} className="text-amber-500 text-base" />
					{title || t("chargeMonitor.confirmAction")}
				</h2>
			</div>

			<p className="text-sm text-mute-700 mb-4">{message || t("chargeMonitor.confirmProceed")}</p>

			{Object.keys(extraInfo).length > 0 && (
				<ModalInfoList className="border-t border-mute-100 pt-3 mb-4">
					{Object.entries(extraInfo).map(([key, value]) => (
						<ModalInfoRow
							key={key}
							label={t(EXTRA_INFO_KEYS[key] || key, { defaultValue: key })}
						>
							{value || "–"}
						</ModalInfoRow>
					))}
				</ModalInfoList>
			)}

			<div className="flex justify-end gap-3">
				<button
					className="btn btn-outline-primary"
					onClick={onClose}
				>
					{t("common.cancel")}
				</button>

				<button
					className="btn-primary btn"
					onClick={() => {
						onConfirm();
						onClose();
					}}
				>
					{confirmLabel || t("common.confirm")}
				</button>
			</div>
		</ModalBase>
	);
};

export default ConfirmModal;
